import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { Box, Typography } from 'app/shared/components/atoms';

interface Props {
  isEarlyBird?: boolean;
  currencySymbol: string;
  ticketPrice: number;
  earlyBirdOriginalPrice?: number;
}

const TicketPrice: React.FC<React.PropsWithChildren<Props>> = ({
  currencySymbol,
  isEarlyBird,
  earlyBirdOriginalPrice,
  ticketPrice,
}) => {
  const { colors } = useCurrentTheme();
  const intl = useIntl();

  if (!isEarlyBird || !earlyBirdOriginalPrice) {
    return (
      <Typography
        fontSize="fontSize400"
        fontWeight="medium"
        fontFamily="title"
        data-qaid="event-page-cta-price"
      >
        {currencySymbol}
        {ticketPrice}
      </Typography>
    );
  }

  return (
    <Box>
      <Box flexDirection="row" alignItems="center">
        <Typography
          fontSize="fontSize500"
          fontWeight="bold"
          data-qaid="event-page-checkout-widget-early-bird-ticket-price"
          lineHeight="100%"
          color={colors.messaging.error.dark}
          mr={2}
        >
          {currencySymbol}
          {ticketPrice}
        </Typography>
        <Typography
          fontSize="fontSize300"
          data-qaid="event-page-checkout-widget-early-bird-original-ticket-price"
          lineHeight="100%"
          textDecoration="line-through"
          color={colors.primary.black.lightest}
        >
          {currencySymbol}
          {earlyBirdOriginalPrice}
        </Typography>
      </Box>
      <Typography
        fontSize="fontSize50"
        fontWeight="semibold"
        data-qaid="event-page-checkout-widget-early-bird-description"
        lineHeight="100%"
        color={colors.messaging.error.dark}
        mr={2}
      >
        {intl.formatMessage({
          id: 'event.expressCheckout.earlyBird.description',
        })}
      </Typography>
    </Box>
  );
};

export default TicketPrice;
